import { TagOutlined } from '@ant-design/icons';
import type { ReactNode } from 'react';
import styled from 'styled-components';

import BookmarkIcon from '@/assets/icons/BookmarkIcon';
import ManualIcon from '@/assets/icons/ManualIcon';
import AIIcon from '@/components/Badge/AIBadge/AIIcon';
import { CenterFlex, Flex } from '@/components/base';
import Typo from '@/components/Typography/Typo';
import { TOPIC_2_TYPE } from '@/types/taxonomyConst';

type Props = {
  type: TOPIC_2_TYPE;
};

export const Topic2TypeNameMap: Record<TOPIC_2_TYPE, string> = {
  [TOPIC_2_TYPE.AI]: 'AI',
  [TOPIC_2_TYPE.RULE]: 'Rule',
  [TOPIC_2_TYPE.MANUAL]: 'Manual',
  [TOPIC_2_TYPE.SAVED_TOPIC]: 'Saved topic',
};

export const Topic2TypeIconMap: Record<TOPIC_2_TYPE, ReactNode> = {
  [TOPIC_2_TYPE.AI]: <AIIcon />,
  [TOPIC_2_TYPE.RULE]: <TagOutlined />,
  [TOPIC_2_TYPE.MANUAL]: <ManualIcon />,
  [TOPIC_2_TYPE.SAVED_TOPIC]: <BookmarkIcon />,
};

const TopicTypeLabel = (props: Props) => {
  return (
    <Style a="center" g={4}>
      <CenterFlex className="icon">{Topic2TypeIconMap[props.type]}</CenterFlex>
      <Typo type="label2" weight="r">
        {Topic2TypeNameMap[props.type]}
      </Typo>
    </Style>
  );
};

const Style = styled(Flex)`
  color: ${(props) => props.theme.colors.gray600};
  .icon {
    font-size: 12px;
    color: ${(props) => props.theme.colors.gray600};
    border-radius: ${(props) => props.theme.radius.token['3.5xl']}px;
    svg {
      width: 16px;
      aspect-ratio: 1;
      fill: ${(props) => props.theme.colors.gray600};
    }
  }
`;

export default TopicTypeLabel;
